export default "__VITE_ASSET__DHAYXwwx__"